/*
 * Copyright 1999-2024 Jagex Ltd.
 */
/**
 * Marker interface, describes actual entities
 */
export interface Entity {}

/**
 * Describes entities that have optimistic locking implemented
 */
export interface VersionableEntity extends Entity {
  version: number;
}

export interface HttpErrorBody {
  traceId?: string;
  spanId?: string;
  status: number;
  code: string;
  message: string;
  id?: string;
  additionalFields?: Record<string, any>;
}

export interface HttpRequestNetworkError {
  message: string;
  errorType: 'httpRequest';
}

export interface HttpResponseNetworkError {
  message: string;
  errorType: 'httpResponse';
  data: Partial<HttpErrorBody>;
}

export interface GeneralNetworkError {
  message: string;
  errorType: 'general';
}

export type NetworkError = HttpRequestNetworkError | HttpResponseNetworkError | GeneralNetworkError;

export type QueryParam = string | string[] | undefined;

export interface ValidationResult {
  field: string;
  message: string;
  code: string;
}

export class ValidationError<D extends ValidationResult = ValidationResult> extends Error {
  public readonly errors: D[];

  constructor(...errors: D[]) {
    super('Validation Error');

    this.errors = errors;
  }
}
